import BaseApi from "../BaseApi";

class BaseUser extends BaseApi{
    constructor() {
        super();
    }

    static getVersion() {
        return 1;
    }

}


export default BaseUser;